/* ----------------------------------------- */
  // Our API parse the strings >1 & <1 from the spreasheet to this number below
  export const GREATER_THEN_ONE_NUMBER = 9876543210  
/* ----------------------------------------- Forecast */